import {
	_post,
	_get,
	_download,
	_upload
} from "./request";

/***********************公共文件上传*************************/
export const reqUploadFile = (data, progress) => _upload(`index.php/upload_file`, data, progress);

/***********************登录相关*************************/
export const reqLoginName = (data) => _post(`index.php/login_home`, data); // 获取单位名称

export const reqRegistOpen = (data) => _post(`index.php/regist_open`, data); // 报名开放

export const reqToLogin = (data) => _post(`index.php/to_login`, data); // 直通登录

export const reqGetExaminationList = () => _get(`index.php/get_examination_list`); // 报名考试列表

export const reqGetExaminationListNew = () => _get(`index.php/get_examination_list_new`); // 面试报名考试列表

export const reqGetInstructionTxt = (data) => _post(`index.php/get_instruction_txt`, data); //获取报名须知和承诺书

export const reqShowAddCandidate = (data) => _post(`index.php/show_add_candidate`, data); //回显新增考生报名信息

export const reqShowPositionType = (data) => _post(`index.php/show_position_type`, data); // 回显岗位类别

export const reqShowParent = (data) => _post(`index.php/show_parent`, data); // 回显主管单位

export const reqShowDepartment = (data) => _post(`index.php/show_department`, data); // 回显招聘单位

export const reqAddCandidate = (data) => _post(`index.php/add_candidate`, data); // 新增考生报名

export const reqGetIdentity = () => _get(`index.php/get_identity`); // 获取登录的身份标识

export const reqLogin = (data) => _post(`index.php/login`, data); //考生登录

export const reqShowRetrieveLoginId = (data) => _post(`index.php/show_retrieve_login_id`, data); //回显找回报名序号

export const reqRetrieveLoginId = (data) => _post(`index.php/retrieve_login_id`, data); // 找回报名序号

/***********************业务接口***********************/
export const reqGetUserPhoto = () => _get(`index.php/get_user_home`); //获取考生照片

export const reqGetUserInfoAside = () => _get(`index.php/aside_user_info`); // 获取考生菜单

export const reqGetUserInfo = () => _get(`index.php/get_user_info`); // 获取考生详情

export const reqPositionTotal = (data) => _post(`index.php/position_total`, data); //岗位报名统计

export const reqGetTravelInfo = () => _get(`index.php/get_travel_info`); // 获取考生行程详情

export const reqEditCandidate = (data) => _post(`index.php/edit_candidate`, data); // 考生信息维护

export const reqShowAddTravel = (data) => _post(`index.php/show_add_travel`, data); //回显新增考生行程信息

export const reqAddTravel = (data) => _post(`index.php/add_travel`, data); // 新增考生行程

export const reqEditTravel = (data) => _post(`index.php/edit_travel`, data); // 考生行程修改

export const reqEditCandidatePhoto = (data) => _post(`index.php/edit_candidate_photo`, data); // 考生照片维护

export const reqGetExplain = (data) => _post(`index.php/get_explain`, data); // 获取注意事项

export const reqGetCandidateScore = () => _get(`index.php/get_candidate_score`); // 考生成绩查询

export const reqGetPayment = (data) => _post(`index.php/get_payment`, data); // 支付下单

export const reqAddConfirm = (data) => _post(`index.php/add_confirm`, data); // 新增参考确认

export const reqAddRefund = (data) => _post(`index.php/add_refund`, data); // 新增退费申请

export const reqGetEditCandidateInfo = () => _get(`index.php/edit_candidate_info`); // 考生修改获取信息

export const reqGetPhotoCandidateInfo = () => _get(`index.php/photo_candidate_info`); // 考生修改照片获取信息

export const reqGetConfirmCandidateInfo = () => _get(`index.php/confirm_candidate_info`); // 考生参考确认获取信息

export const reqGetPayCandidateInfo = () => _get(`index.php/pay_candidate_info`); // 考生缴费获取信息

export const reqGetRefundCandidateInfo = () => _get(`index.php/refund_candidate_info`); // 考生申请退费获取信息

export const reqGetPrintCandidateInfo = () => _get(`index.php/print_candidate_info`); // 考生准考证获取信息

export const reqGetInterviewCandidateInfo = () => _get(`index.php/interview_candidate_info`); // 考生面试通知获取信息

export const reqPrintCandidate = (data) => _post(`index.php/print_candidate`, data); //打印考生准考证

export const reqPrintInterview = (data) => _post(`index.php/print_interview`, data); //打印面试通知
